import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get_open_orders, getClosedOrders } from '../actions/index';

class PosSearchNav extends Component {
  constructor(props) {
      super(props);

      this.state = {
        search: '',
        page: 1,
      }
  }

  handleSearchSubmit = event => {
    event.preventDefault();

    if (this.props.orderType === "open") {
      this.props.get_open_orders(1, this.state.search);
    } else if (this.props.orderType === "closed") {
      this.props.getClosedOrders(1, this.props.date, this.state.search);
    }
  }

  handleSearchChange = event => {
    this.setState({ search: event.target.value });
  }

  render() {
    return(
      <div className="col-sm-auto text-xs-center text-md-right pr-1 pl-1">
        <div className="pt-2 hidden-sm-up"></div>
        <form onSubmit={this.handleSearchSubmit} className="form-inline navbar-item ml-1 float-xs-right">
          <div className="input-group">
            <input type="text" onChange={this.handleSearchChange} value={this.state.search} className="form-control b-a" placeholder="Search for..." />
            <span className="input-group-btn">
              <button type="submit" className="btn bg-white b-a">
                <i className="ti-search"></i>
              </button>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { get_open_orders, getClosedOrders }, dispatch);
}

export default connect(null, mapDispatchToProps)(PosSearchNav);



// WEBPACK FOOTER //
// ./src/containers/pos_search_nav.js